import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';
import { getDevicesList, deleteDevices, activeDevice, offlineDevicesDetail, exportDevices, } from '@blade-sxp/monitor/api/device-management/control';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { AlarmWebsocket as StatusWebsocket } from '@blade/common/utils/websocket';
let default_1 = class default_1 extends Vue {
    keywords;
    groupId;
    confirm = '';
    deviceConfirmDelete = '';
    deviceConfirmActive = '';
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    // filtersData = [
    //   { text: this.$t('common.normal'), value: 1 },
    //   { text: this.$t('common.disable'), value: 0 },
    //   { text: this.$t('common.unableToConnect'), value: 2 },
    // ];
    devicesList = [];
    multipleSelection = [];
    upWS;
    upWSurl = this.mapUrl();
    listLoading = false;
    deviceStatus = '';
    mapUrl() {
        const res = process.env.NODE_ENV === 'development'
            ? process.env.VUE_APP_REALTIME_WS
            : `wss://${window.location.host}/${process.env.VUE_APP_REALTIME_WS}`;
        return res || '';
    }
    initWebsocket() {
        console.log(this.upWSurl, 'this.upWSurl');
        // this.upWSurl = "ws://10.8.10.29:31235/message-push-service/realtime"
        this.upWS = new StatusWebsocket(this.upWSurl);
        this.upWS.setOnMessage(this.websocketonmessage);
    }
    websocketonmessage(e) {
        // console.log(e.data,'e.data');
        let msg = JSON.parse(e.data);
        if (msg?.messageType === 'UMC_DEVICE_STATUS') {
            if (this.devicesList.length > 0) {
                let changeIndex = this.devicesList.findIndex(item => item.deviceId === msg.deviceId);
                if (changeIndex !== -1 && changeIndex < this.devicesList.length) {
                    let temp = this.devicesList.slice();
                    temp[changeIndex].deviceStatus = msg.content.deviceStatus;
                    this.devicesList = temp;
                }
            }
        }
    }
    // private isSelectAll:boolean=false;
    /**
     *@Description: 选择列表
     *@Date: 2020-09-10 18:20:13
     */
    handleSelectionChange(val) {
        this.multipleSelection = val;
    }
    /**
     *@Description: 清空
     *@Date: 2020-09-10 18:19:59
     */
    handleClear(rows) {
        this.$refs.multipleTable.clearSelection();
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.refresh();
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.refresh();
    }
    /**
     *@Description: status 过滤
     *@Date: 2020-09-10 16:19:39
     */
    filterTag(value, row) {
        return row.deviceStatus === value;
    }
    /**
     *@Description: 获取设备列表
     *@Date: 2020-09-10 18:17:12
     */
    getDevicesList(keywords) {
        let data = {
            keywords: keywords,
            deviceStatus: this.deviceStatus,
            page: this.pagination.page,
            size: this.pagination.size,
        };
        if (this.groupId) {
            data.groupId = this.groupId;
        }
        this.listLoading = true;
        getDevicesList(data)
            .then((resp) => {
            this.devicesList = resp?.data?.data?.list || [];
            // this.pagination.size = resp?.data?.data?.size;
            this.pagination.total = resp?.data?.data?.total;
            // this.pagination.page = resp?.data?.data?.page;
        })
            .catch((e) => {
            console.log('e:', e);
        })
            .finally(() => {
            this.listLoading = false;
        });
    }
    onFilterChange(filters) {
        if (filters.deviceStatus) {
            this.pagination.page = 1;
            this.deviceStatus = filters.deviceStatus[0];
            this.getDevicesList();
        }
        // this.$forceUpdate() // TODO: remove if need
    }
    /**
     *@Description:  跳转编辑设备
     *@Date: 2020-09-10 18:16:57
     */
    handleEdit(sid) {
        const id = sid.toString() || '';
        this.$router.push({ path: '/users/control/editDevice', query: { id } });
    }
    /**
     *@Description: 删除设备
     *@Date: 2020-09-10 18:16:47
     */
    handleDelete(sid) {
        this.confirm = `${this.$t('common.confirm')}`;
        this.deviceConfirmDelete = `${this.$t('device.confirmDelete')}`;
        this.$alert(this.deviceConfirmDelete, {
            confirmButtonText: this.confirm,
            callback: action => {
                if (action === 'confirm') {
                    deleteDevices(sid)
                        .then(res => {
                        this.$message({
                            message: res.data.message,
                            type: 'success',
                        });
                        this.refresh();
                    })
                        .catch(err => {
                        this.$message({
                            message: err,
                            type: 'error',
                        });
                    });
                }
            },
        });
    }
    /**
     *@Description: 停用/启用
     *@Date: 2020-09-10 18:17:40
     */
    activeDevice(sid, deviceStatus) {
        if (deviceStatus) {
            // 停用设备
            this.confirm = `${this.$t('common.confirm')}`;
            this.deviceConfirmActive = `${this.$t('device.confirmDisable')}`;
            this.$alert(this.deviceConfirmActive, {
                confirmButtonText: this.confirm,
                callback: action => {
                    if (action === 'confirm') {
                        offlineDevicesDetail(sid)
                            .then(res => {
                            this.$message({
                                message: res.data.message,
                                type: 'success',
                            });
                            this.refresh();
                        })
                            .catch(err => {
                            this.$message({
                                message: err,
                                type: 'error',
                            });
                        });
                    }
                },
            });
        }
        else {
            // 激活设备
            this.confirm = `${this.$t('common.confirm')}`;
            this.deviceConfirmActive = `${this.$t('device.confirmActive')}`;
            this.$alert(this.deviceConfirmActive, {
                confirmButtonText: this.confirm,
                callback: action => {
                    if (action === 'confirm') {
                        activeDevice(sid)
                            .then(resp => {
                            this.$message({
                                message: resp.data.message,
                                type: 'success',
                            });
                            this.refresh();
                        })
                            .catch(err => {
                            this.$message({
                                message: err,
                                type: 'error',
                            });
                        });
                    }
                },
            });
        }
    }
    refresh() {
        this.pagination.page = 1;
        this.getDevicesList(this.keywords);
    }
    mounted() {
        this.refresh();
        this.initWebsocket();
    }
    beforeDestroy() {
        this.upWS?.close();
    }
    handleSelectAll(val) {
        // this.isSelectAll= !this.isSelectAll;
        // console.log(val);
    }
    async exportCsv() {
        if (this.multipleSelection.length === 0) {
            this.$message.error(this.$t('exportedData').toString());
            return;
        }
        const deviceIds = this.multipleSelection.map((item) => item.deviceId);
        let param = {};
        if (this.groupId) {
            param = {
                deviceIds,
                keywords: this.keywords,
                groupId: this.groupId,
                ...this.pagination,
            };
        }
        else {
            param = { deviceIds, keywords: this.keywords, ...this.pagination };
        }
        const resp = await exportDevices(param);
        this.$alert(this.$t('common.csv').toString(), 'Title', {
            confirmButtonText: this.$t('common.confirm').toString(),
            callback: action => {
                console.log(resp);
                if (action === 'confirm') {
                    if (resp?.data?.data) {
                        console.log(resp?.data?.data);
                        window.location.href = resp.data.data;
                    }
                }
            },
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "keywords", void 0);
__decorate([
    Prop()
], default_1.prototype, "groupId", void 0);
default_1 = __decorate([
    Component({
        name: 'DeviceList',
        components: { AuthItem },
        filters: {
            toFormat: (num) => {
                return num ? moment(num).format('YYYY-MM-DD hh:mm:ss') : '';
            },
        },
        i18n: {
            messages: {
                'en-us': {
                    filtersData: [
                        { text: 'Normal', value: '1' },
                        { text: 'Disable', value: '0' },
                        { text: 'Unable', value: '2' },
                    ],
                    exportedData: 'Please select the data to be exported',
                    normal: 'Normal',
                },
                zh: {
                    filtersData: [
                        { text: '已连接', value: '1' },
                        { text: '停用', value: '0' },
                        { text: '无法连接', value: '2' },
                    ],
                    exportedData: '请选择需要导出的数据',
                    normal: '已连接',
                },
            },
        },
    })
], default_1);
export default default_1;
